module.exports = __webpack_public_path__ + "img/mailing-1.b419e960.png";